import { HttpClient } from '@angular/common/http';
import { makeEnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { ConfigInitializerService } from '../../config/config-initializer/config-initializer.service';
import { LanguageService } from '../../site-context/facade/language.service';
import { SERVER_REQUEST_ORIGIN } from '../../util/ssr.tokens';
import { i18nextInit, SiteContextI18nextSynchronizer } from './i18next-init';
import { I18NEXT_INSTANCE } from './i18next-instance';


export const i18nextProviders = makeEnvironmentProviders([
  provideAppInitializer(() =>
    i18nextInit(
      inject(I18NEXT_INSTANCE),
      inject(ConfigInitializerService),
      inject(LanguageService),
      inject(HttpClient),
      inject(SERVER_REQUEST_ORIGIN, { optional: true }),
      inject(SiteContextI18nextSynchronizer)
    )()
  ),
]);
